module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAgElEQVQ4y2NgGBTg32mG/+RgOhhwRRuCyTXg/9MGIG4kbIDJJuP/yLjrcuf/k69O/v/86zMYg9ggMXR1OA0w3WTyf/Gdxf9hYPGdRWAxog0A4Z7L3f/f/XwHxiA2NjVwA15pWP5Hx587Jv1/Y+MDxp/bJ/7HpgavAcTgQWTA0AYAKb2KSBPQ+XQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MM.png
// module id = 1209
// module chunks = 0